import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { useDispatch } from 'react-redux';
import { contentfulConfigType } from '../../proptypes/contentful';
import { shareSpyRoleAction } from '../../actions/action-creators';
import { useContentfulEntry } from '../../hooks/contentful';
import Modal from '../Modal';
import MarkdownBlock from '../MarkdownBlock';

const instagramShareTipEntryId = '6uSXJrAPudqcN8LKXf5Pj5';

const selectInstaMarkdown = entry => get(entry, 'fields.content', '');

const ModalPortal = ({ children, modalNodeId }) => {
  const modalNode = useRef(document.createElement('div'));

  useEffect(() => {
    const modalRoot = document.getElementById(modalNodeId);
    modalRoot.appendChild(modalNode.current);

    return () => {
      if (!modalNode.current) return;
      modalNode.current.remove();
    };
  }, []);

  return ReactDOM.createPortal(
    children,
    modalNode.current,
  );
};

const withInstagramModal = Component => (outerProps) => {
  const WrappedComponent = (props) => {
    const [showModal, setShowModal] = useState(false);
    const {
      spyRole,
      shareImageUrl,
      contentfulConfig,
      modalNodeId,
    } = props;

    const dispatch = useDispatch();
    const instaMarkdown = selectInstaMarkdown(
      useContentfulEntry(contentfulConfig, instagramShareTipEntryId),
    );

    const handleShare = ({ event, id: socialNetwork }) => {
      if (socialNetwork === 'Instagram') {
        event.preventDefault();
        setShowModal(true);
      }

      dispatch(shareSpyRoleAction({ socialNetwork, spyRole }));
    };

    const handleClose = () => setShowModal(false);

    return (
      <>
        <Component
          {...props}
          onShare={handleShare}
        />
        <ModalPortal modalNodeId={modalNodeId}>
          <Modal show={showModal} onClose={handleClose}>
            <MarkdownBlock
              markdown={instaMarkdown}
              imageUrl={shareImageUrl}
            />
          </Modal>
        </ModalPortal>
      </>
    );
  };

  WrappedComponent.defaultProps = {
    modalNodeId: 'modal-root',
  };

  WrappedComponent.propTypes = {
    modalNodeId: PropTypes.string,
    spyRole: PropTypes.string.isRequired,
    shareImageUrl: PropTypes.string.isRequired,
    contentfulConfig: contentfulConfigType.isRequired,
  };

  return <WrappedComponent {...outerProps} />;
};

export default withInstagramModal;
